import {getAPIGatewayDataFromParent} from "../handler/ParentDataHandler";
import {publishCount, publishTime} from "../MetricUtility";
import {ERROR_METRIC_SUFFFIX} from "../constants";

const metricProcessName = "SCC_STOW";
const metricName = "getGridAllocationData";
const getSortLocationForNodeEndPoint = '/sls/get-sort-location-node';
const spgProcessName = "sortPathGenerator";

/**
 * Get Sort grid reservation details for a given node
 *
 * @param nodeId identifier of the node
 * @returns {Promise<*>}
 */
export async function getSortGridAllocationForNode(nodeId) {
    const startTime = Date.now();
    const requestBody = {
        stationCode: nodeId
    };
    const request = getSortPathGeneratorAPIGatewayRequest(getSortLocationForNodeEndPoint, requestBody);
    const response = await getAPIGatewayDataFromParent(request);

    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return response.data;
    }
    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
}

function getSortPathGeneratorAPIGatewayRequest(endpoint, request, httpMethod = "POST") {
    return {
        resourcePath: endpoint,
        httpMethod: httpMethod,
        processName: spgProcessName,
        requestBody: request
    }
}


// WEBPACK FOOTER //
// ./src/resources/GridAllocationResource.js